import React from 'react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function AppLoadingScreen(): React.ReactElement {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full mx-4">
        <div className="text-center">
          {/* Logo */}
          <div className="mb-6">
            <img
              className="h-20 mx-auto"
              src="/logoipsum-custom-logogram.svg"
              alt="OptoSoft Logo"
            />
          </div>

          {/* Loading Spinner */}
          <div className="mb-4">
            <FontAwesomeIcon icon={faSpinner} className="w-8 h-8 text-blue-600 animate-spin" />
          </div>

          {/* Loading Text */}
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Carregando...</h2>
          <p className="text-gray-600">Inicializando sistema da clínica</p>

          {/* Progress Animation */}
          <div className="mt-6">
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-blue-600 h-2 rounded-full animate-pulse"
                style={{ width: '70%' }}
              ></div>
            </div>
          </div>

          {/* Clinic Name */}
          <div className="mt-4">
            <p className="text-sm text-gray-500">Clínica DRA. Andreia Anacleto</p>
          </div>
        </div>
      </div>
    </div>
  );
}
